import { render, staticRenderFns } from "./Notifiaction.vue?vue&type=template&id=895aa30e"
import script from "./Notifiaction.vue?vue&type=script&lang=js"
export * from "./Notifiaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports